import { render, staticRenderFns } from "./FamiliesMembersDetails.vue?vue&type=template&id=1afda4b7"
import script from "./FamiliesMembersDetails.vue?vue&type=script&lang=js"
export * from "./FamiliesMembersDetails.vue?vue&type=script&lang=js"
import style0 from "./FamiliesMembersDetails.vue?vue&type=style&index=0&id=1afda4b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports